// extracted by mini-css-extract-plugin
module.exports = {"ExtraText":"Tooltip_ExtraText__vEV8r","SquaredBox":"Tooltip_SquaredBox__1nEJa","BoxPosition":"Tooltip_BoxPosition__oCtP3"};